import styled, { css } from 'styled-components';
import Typography from '../../typography';
import { pxToRem } from '../../../design-tokens/style-utilities';
import { ANWBDefault } from '../../../design-tokens/theme';
import { TagLabelContainer } from '../components/TagLabel';
const TAG_HEIGHT_INFORMATIVE = 38;
const TAG_HEIGHT_INTERACTIVE = 40;
const TAG_MAX_WIDTH = 450;
/**
 * Tag container
 */
export const tagContainerStyles = ({ theme }) => css `
	position: relative;
	display: inline-flex;
	align-items: center;
	gap: ${pxToRem(theme.spacing['100'])};
	height: ${pxToRem(TAG_HEIGHT_INFORMATIVE)};
	padding: ${theme.name === ANWBDefault.name
    ? `${pxToRem(theme.spacing['100'])} ${pxToRem(theme.spacing['200'])}`
    : `${pxToRem(theme.spacing['100'])} ${pxToRem(theme.spacing['200'])}`};
	border-radius: ${theme.name === ANWBDefault.name
    ? pxToRem(theme.borderRadius.m)
    : pxToRem(theme.borderRadius.rounded)};
	background-color: ${theme.colors.extralight.bgTag};
	text-decoration: none;
	white-space: nowrap;
	width: auto;
`;
export const TagContainer = styled(Typography).attrs({
    variant: 'body-text-xs',
}) `
	${tagContainerStyles}
`;
export const interactiveTagContainerStyles = ({ theme, $removable, }) => css `
	height: ${pxToRem(TAG_HEIGHT_INTERACTIVE)};
	padding: ${theme.name === ANWBDefault.name
    ? `${pxToRem(theme.spacing['100'])} ${pxToRem(theme.spacing['200'])}`
    : `${pxToRem(theme.spacing['200'])} ${pxToRem(theme.spacing['300'])}`};
	cursor: pointer;
	border: none;

	&:focus,
	&:hover {
		color: ${theme.colors.highlight.textHover};
		background-color: ${theme.colors.light.bgTagHover};
	}

	&:active {
		color: ${theme.name === ANWBDefault.name
    ? theme.colors.action.textActive
    : theme.colors.blanc.textInverse};
		background-color: ${theme.colors.base.bgTagActive};
	}

	&:focus-visible {
		outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
		outline-offset: ${theme.borderWidth.m}px;
	}

	${$removable &&
    css `
		${TagLabelContainer} {
			max-width: ${pxToRem(TAG_MAX_WIDTH)};
			overflow: hidden;
			text-overflow: ellipsis;
			transition: max-width 0.3s ease-out;
		}
	`}
`;
export const InteractiveTagContainer = styled(Typography).attrs({
    variant: 'tag-text',
}) `
	${tagContainerStyles}
	${interactiveTagContainerStyles}
`;
